export const manifest = {
  screens: {
    scr_0tzijz: { name: "Accueil", route: "/", position: {"x":160,"y":220} },
    scr_sdmjvb: { name: "Services", route: "/services", position: {"x":1560,"y":220} },
    scr_9ket85: { name: "À propos", route: "/a-propos", position: {"x":2960,"y":220} },
    scr_zjmuhe: { name: "Portfolio", route: "/portfolio", position: {"x":4360,"y":220} },
    scr_c0ov8z: { name: "Contact", route: "/contact", position: {"x":5760,"y":220} },
  },
  sections: {
    sec_1uk0do: { name: "Main Navigation", x: 0, y: 0, width: 7120, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_1uk0do", children: [
      { kind: "screen", id: "scr_0tzijz" },
      { kind: "screen", id: "scr_sdmjvb" },
      { kind: "screen", id: "scr_9ket85" },
      { kind: "screen", id: "scr_zjmuhe" },
      { kind: "screen", id: "scr_c0ov8z" },
    ] },
  ],
}
